import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import {Input} from 'ui-library';
import _ from 'lodash';


import API from '../lib/api';
import Mixins from '../lib/mixins';
import is from 'is_js';

import UploadAvatarContainer from './upload-avatar-container';

var SettingsAdvertiserContent = createClass({

  mixins: [Mixins.linkMixin],

  propTypes: {
    onSave: PropTypes.func,
    account: PropTypes.object
  },


  getInitialState() {
    var {account} = this.props;

    return {
      name: account.name,
      web: account.web
    };
  },

  onUploadAvatar(id, image) {
    const {account} = this.props;

    API.updateAccount({
      image,
      _id: account._id
    });
  },

  validateTypes: {
    web: (url) => {
      if (!url) return true;
      return is.url(url);
    }
  },

  onSave() {
    var {account} = this.props;
    var {name, web} = this.state;

    if (!this.validateAll()) return;

    API.auto('updateAccount', {
      _id: account._id,
      name: name,
      web: web
    }, {
      successMessage: 'Se ha guardado con éxito',
      callback: (err) => {
        if (err) return console.error(err);
        if (_.has(this.props, 'onSave')) this.props.onSave();
      }
    });
  },

  render() {
    var {account} = this.props;
    var image = account.image;
    return (
      <div>
        <div className='md-4 vf-settings-avatar'>
          <UploadAvatarContainer image={image} onChange={this.onUploadAvatar}/>
        </div>
        <div className='padding-horizontal-1x column md-8'>
          <div className='padding-bottom-1x'>
            <label className='vf-simple-form-label'>Nombre comercial de tu marca (opcional)</label>
            <div className='vf-descriptor'>
              Ejemplo: VoxFeed
            </div>
            <Input {...this.linkedValidation('name')} placeholder='Nombre de tu marca' />
          </div>

          <div className='padding-bottom-2x'>
            <label className='vf-simple-form-label'>Web (opcional)</label>
            <div className='vf-descriptor'>
              Tu sitio web
            </div>
            <Input {...this.linkedValidation('web')} placeholder='http://website.com' />
          </div>
        </div>
      </div>
    );
  }

});

module.exports = SettingsAdvertiserContent;
